import {
  Route,
  Routes,
  BrowserRouter as Router,
  useNavigate,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import DailyActivity from "./pages/DailyActivity";
import PrivateRoute from "./components/authentication/PrivateRoute";
import Record from "./pages/Record";
import EditRecord from "./pages/EditRecord";
import InterdepartmentalMovement from "./pages/InterdepartmentalMovement";
import Master from "./pages/Master";
import VetTreatment from "./pages/VetTreatment";
import Upload from "./pages/Upload";
import TrackingDevice from "./pages/TrackingDevice";
import Sample from "./pages/Sample";
import Release from "./pages/Release";
import PhysicalMeasurements from "./pages/PhysicalMeasurements";
import Microchip from "./pages/Microchip";
import InfantFeeding from "./pages/InfantFeeding";
import CriminalCase from "./pages/CriminalCase";
import "./App.css";
import Login from "./pages/Login";
// Auto generates routes from files under ./pages

export default function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Dashboard />} />
            <Route exact path="/daily-activity" element={<DailyActivity />} />
            <Route exact path="/record" element={<Record />} />
            <Route exact path="/view-record" element={<EditRecord />} />
            <Route
              exact
              path="/interdepartmental-movement"
              element={<InterdepartmentalMovement />}
            />
            <Route exact path="/master" element={<Master />} />
            <Route exact path="/master/:reference" element={<Master />} />
            <Route exact path="/vet-treatment" element={<VetTreatment />} />
            <Route exact path="/upload" element={<Upload />} />
            <Route exact path="/tracking-device" element={<TrackingDevice />} />
            <Route exact path="/sample" element={<Sample />} />
            <Route exact path="/release" element={<Release />} />
            <Route
              exact
              path="/physical-measurements"
              element={<PhysicalMeasurements />}
            />
            <Route exact path="/microchip" element={<Microchip />} />
            <Route exact path="/infant-feeding" element={<InfantFeeding />} />
            <Route exact path="/record/edit/:id" element={<Record />} />
            <Route
              exact
              path="/daily-activity/edit/:id/:reference"
              element={<DailyActivity />}
            />
            <Route
              exact
              path="/interdepartmental-movement/edit/:id/:reference"
              element={<InterdepartmentalMovement />}
            />
            <Route
              exact
              path="/vet-treatment/edit/:id/:reference"
              element={<VetTreatment />}
            />
            <Route
              exact
              path="/upload/edit/:id/:reference"
              element={<Upload />}
            />
            <Route
              exact
              path="/tracking-device/edit/:id/:reference"
              element={<TrackingDevice />}
            />
            <Route
              exact
              path="/sample/edit/:id/:reference"
              element={<Sample />}
            />
            <Route
              exact
              path="/release/edit/:id/:reference"
              element={<Release />}
            />
            <Route
              exact
              path="/physical-measurements/:id/:reference"
              element={<PhysicalMeasurements />}
            />
            <Route exact path="/microchip/edit/:id" element={<Microchip />} />
            <Route
              exact
              path="/infant-feeding/:id/:reference"
              element={<InfantFeeding />}
            />
            <Route
              exact
              path="/criminal-case/:id/:reference"
              element={<CriminalCase />}
            />
          </Route>
          <Route exact path="/login" element={<Login />} />
        </Routes>
      </Router>
    </>
  );
}
